/* 🤖 this file was generated by svg-to-ts */
export const matIconViewStream: {
  name: 'view-stream';
  data: string;
} = {
  name: 'view-stream',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 7v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 10H5v-4h14v4zM5 11V7h14v4H5z"/></svg>`
};
